import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'
import InputCustom from '../../components/atoms/input/InputCustom'
import CommonModal from '../../components/atoms/modal/CommonModal'
import styles from './ChatPageV2.module.scss'
import { getNewChatUsers } from '../../features/messageSlice'
import { ThreeDotsLoader } from '../../components/atoms/loader/ThreeDotsLoader'

export function IndividualModal({ open, handleClose, statusMap, onSuccess }) {
	const dispatch = useDispatch()
	const { kazooId } = useParams()
	const onlineUsers = useSelector((s) => s.auth.onlineUsers)
	const newChatUserList = useSelector((s) => s.message.newChatUserList)
	const newChatLoading = useSelector((s) => s.message.newChatLoading)
	const [debouncing, setDebouncing] = useState(true)
	const [searchQuery, setSearchQuery] = useState('')

	useEffect(() => {
		if (open) {
			const delayDebounceFn = setTimeout(() => {
				dispatch(
					getNewChatUsers({
						search: searchQuery,
						chatType: kazooId ? 'inSide' : 'outSide',
						kazooId: kazooId,
					})
				)
				setDebouncing(false)
			}, 500)

			return () => clearTimeout(delayDebounceFn)
		}
	}, [open, searchQuery, kazooId, dispatch])

	if (!open) return null

	const filtered = newChatUserList

	return (
		<CommonModal open={open} handleClose={handleClose} heading="New Chat">
			<div className={styles.modalBody}>
				<div className={styles.searchContainer}>
					<InputCustom
						type="text"
						name="search"
						id="search"
						placeholder="Search Users by name or email"
						error={false}
						searchIcon={true}
						value={searchQuery}
						onChange={(e) => {
							setSearchQuery(e.target.value)
							setDebouncing(true)
						}}
					/>
				</div>

				<ul
					className={styles.chatList}
					style={{
						maxHeight: 'calc(100dvh - 400px)',
						overflow: 'auto',
					}}
				>
					{newChatLoading || debouncing ? (
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								height: '100px',
							}}
						>
							<ThreeDotsLoader />
						</div>
					) : !Array.isArray(filtered) || !filtered?.length ? (
						<li className={styles.chatItem}>No users found!</li>
					) : (
						filtered.map((user) => (
							<li key={user._id} className={styles.chatItem}>
								<div
									className={`${styles.avatar} ${statusMap[onlineUsers.includes(user._id)]}`}
								>
									<img
										src={
											user.avatar ||
											'/images/profile-user.svg'
										}
										alt="avatar"
										className={styles.avatar__img}
									/>
								</div>

								<div className={styles.chatInfo}>
									<h4 className={styles.userName}>
										{user.businessName ||
											user.preferredName ||
											user.name ||
											`${user.firstName} ${user.lastName}`}
									</h4>
									<p className={styles.lastMessage}>
										{user.role || 'user'}
									</p>
								</div>
								<ButtonCustom
									size="sm"
									variant="outlined"
									className={`${styles.timeStamp} ${styles.sidebarButton}`}
									onClick={() => onSuccess(user)}
								>
									<img
										src="/images/chat-icon.svg"
										alt="chat"
									/>
									Chat now
								</ButtonCustom>
							</li>
						))
					)}
				</ul>
			</div>
		</CommonModal>
	)
}
